import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client";
import { useAuth } from "../context/AuthContext";

const REFRESH_EVENT = "requests:refresh-open-count";

/**
 * Von der Anfragen-Seite nach Genehmigen/Ablehnen aufzurufen, damit das
 * Badge sofort aktualisiert wird, statt bis zu 60s auf das nächste
 * periodische Polling zu warten.
 */
export function notifyOpenRequestsChanged(): void {
  window.dispatchEvent(new Event(REFRESH_EVENT));
}

/**
 * Anzahl offener Benutzeranfragen fürs Badge neben dem Menüpunkt "Anfragen".
 * Wird nur abgefragt, wenn der Benutzer "requests.manage" besitzt (sonst 0,
 * ohne API-Aufruf); danach periodisch sowie sofort nach jeder Genehmigung/
 * Ablehnung aktualisiert (siehe notifyOpenRequestsChanged), damit das Badge
 * auch bei Bearbeitung in einem anderen Tab/Gerät zeitnah aktuell bleibt.
 */
export function useOpenRequestsCount(): number {
  const { hasPermission } = useAuth();
  const canView = hasPermission("requests.manage");
  const [count, setCount] = useState(0);

  const load = useCallback(() => {
    if (!canView) {
      setCount(0);
      return;
    }
    api
      .get<{ count: number }>("/api/requests/open-count")
      .then((r) => setCount(r.count))
      .catch(() => {});
  }, [canView]);

  useEffect(() => {
    load();
    const interval = setInterval(load, 60_000);
    window.addEventListener(REFRESH_EVENT, load);
    return () => {
      clearInterval(interval);
      window.removeEventListener(REFRESH_EVENT, load);
    };
  }, [load]);

  return count;
}
